import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { UserRequestsService } from '../../shared/services/user-requests.service';
import { DownloadJobService } from '../../shared/services/download-job.service';
import { HistoryRow, ServerPagedHistoryGrid } from '../../shared/grid/server-paged-history-grid';
import { Subscription } from 'rxjs';


@Component({
    selector: 'xp-user-requests',
    templateUrl: './user-requests.component.html',
    styleUrl: './user-requests.component.scss'
})
export class UserRequestsComponent implements OnInit, OnDestroy {
    @ViewChild(RouterOutlet) outlet!: RouterOutlet;
    isToggleOn = false;
    selectedTabIndex: number = 0;
    paymentRequestCount = 0;
    expectedRequestCount = 0;
    transferRequestCount = 0;
    journalRequestCount = 0;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userRequestService: UserRequestsService,
        private downloadJobService: DownloadJobService) {

    }

    async ngOnInit() {
        const path = this.route.snapshot.firstChild?.routeConfig?.path;
        switch (path) {
            case 'payment-requests': this.selectedTabIndex = 0; break;
            case 'expect-funds': this.selectedTabIndex = 1; break;
            case 'transfer-request': this.selectedTabIndex = 2; break;
            case 'journal-requests': this.selectedTabIndex = 3; break;
        }

        // Connect for download notifications and pick up a download already running or ready.
        void this.downloadJobService.initialize();
        await this.loadRequestCounts();
    }

    ngOnDestroy() {
        this.childCountSubscription?.unsubscribe();
    }

    private childCountSubscription?: Subscription;

    onOutletActivate(component: any) {
        this.childCountSubscription?.unsubscribe();

        if (component.requestCountsUpdated) {
            this.childCountSubscription = component.requestCountsUpdated.subscribe(() => {
                this.loadRequestCounts();
            });
        }
    }
    private async loadRequestCounts(): Promise<void> {
        try {
            const counts = await this.userRequestService.getRequestCounts();
            this.paymentRequestCount = counts.paymentRequestCount;
            this.expectedRequestCount = counts.expectFundCount;
            this.transferRequestCount = counts.transferFundCount;
            this.journalRequestCount = counts.journalRequestCount;
        } catch (error) {
            console.error('Failed to load request counts', error);
        }
    }

    onTabChange(event: any) {
        this.selectedTabIndex = event.index;

        switch (event.index) {
            case 0: this.router.navigate(['payment-requests'], { relativeTo: this.route }); break;
            case 1: this.router.navigate(['expect-funds'], { relativeTo: this.route }); break;
            case 2: this.router.navigate(['transfer-request'], { relativeTo: this.route }); break;
            case 3: this.router.navigate(['journal-requests'], { relativeTo: this.route }); break;
        }

        this.loadRequestCounts();
    }

    /** The grid the current tab shows; all four request types share one base. */
    private get grid(): ServerPagedHistoryGrid<HistoryRow> | undefined {
        const child = this.outlet?.component;
        return child instanceof ServerPagedHistoryGrid ? child : undefined;
    }

    resetFilters() {
        this.grid?.resetFilters();
    }

    exportData() {
        void this.grid?.exportDataToExcel();
    }

    get isExporting(): boolean {
        return this.grid?.isExporting ?? false;
    }

    get selectedCount(): number {
        return this.grid?.selectedCount ?? 0;
    }

    /** True while a ZIP is being started or prepared; a user may have only one at a time. */
    get downloadBusy(): boolean {
        return this.downloadJobService.inProgress;
    }

    downloadSelectedAsPdf(): void {
        this.grid?.downloadSelectedAsPdf();
    }

}
